import { useEffect, useState } from 'react';

const STORAGE_KEY = 'rtc-offer-deadline';
const DURATION_MS = 3 * 60 * 60 * 1000;

function readDeadline(): number {
  const now = Date.now();
  try {
    const stored = Number(window.localStorage.getItem(STORAGE_KEY));
    if (stored && stored > now) return stored;
    const fresh = now + DURATION_MS;
    window.localStorage.setItem(STORAGE_KEY, String(fresh));
    return fresh;
  } catch {
    return now + DURATION_MS;
  }
}

/** Shared 3-hour countdown per visitor, persisted across reloads. Restarts when it reaches zero. */
export function useCountdown() {
  const [deadline, setDeadline] = useState(readDeadline);
  const [now, setNow] = useState(Date.now);

  useEffect(() => {
    const id = window.setInterval(() => {
      const t = Date.now();
      setNow(t);
      if (t >= deadline) setDeadline(readDeadline());
    }, 1000);
    return () => window.clearInterval(id);
  }, [deadline]);

  const remaining = Math.max(0, deadline - now);
  const hours = Math.floor(remaining / 3_600_000);
  const minutes = Math.floor((remaining % 3_600_000) / 60_000);
  const seconds = Math.floor((remaining % 60_000) / 1000);
  return { hours, minutes, seconds };
}
